export default __webpack_public_path__ + "static/media/678.3b25e70b.jpg";